import { Text, TextElementTypes } from '@picsart/text';
import { FontWeights, Typography } from '@picsart/cascade';
import { SingleToolAppIcon } from '@quicktools/shared-components/components/common/SingleToolAppIcon';
import IconChevronDownSmall from '@picsart/icons/IconChevronDownSmall';
import IconPlusCircleOutline from '@picsart/icons/IconPlusCircleOutline';
import cls from 'classnames';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import IconProfileOutline from '@picsart/icons/IconProfileOutline';

import { MENU_CATEGORIES } from '../../../constants/tools';
import useMenuStore from '../../../services/store/menuStore';
import { MenuCategoryType } from '../../../utils/common/types';
import { CATEGORY_ICON_PROPS, createPath, myWriterPath } from '../../../constants';

import Subcategories from './Subcategories';
import { useStyles } from './styles';

function Menu() {
  const classes = useStyles();
  const { t } = useTranslation();
  const router = useRouter();
  const selectedMenuSubcategory = useMenuStore((state) => state.selectedMenuSubcategory);
  const selectedMenuCategoryType = useMenuStore((state) => state.selectedMenuCategoryType);
  const expandedMenuCategoryType = useMenuStore((state) => state.expandedMenuCategoryType);
  const toggleMenuItem = useMenuStore((state) => state.toggleMenuItem);
  const setMenuSelectedItem = useMenuStore((state) => state.setMenuSelectedItem);
  const resetMenu = useMenuStore((state) => state.resetMenu);
  const isCreateSelected = selectedMenuCategoryType === MenuCategoryType.Create;
  const isMyWriterSelected = selectedMenuCategoryType === MenuCategoryType.MyWriter;

  const menuItems = [
    {
      path: createPath,
      label: t('editor.create'),
      icon: IconPlusCircleOutline,
      isSelected: isCreateSelected,
      category: MenuCategoryType.Create,
    },
    {
      path: myWriterPath,
      icon: IconProfileOutline,
      label: t('editor.my-writer'),
      isSelected: isMyWriterSelected,
      category: MenuCategoryType.MyWriter,
    },
  ];

  useEffect(() => {
    router.beforePopState(() => {
      resetMenu();

      return true;
    });
  }, [router]);

  return (
    <div>
      {menuItems.map((item) => (
        <Link key={item.path} href={item.path} passHref>
          <a className={cls(classes.btn, item.isSelected && classes.btnSelected)}>
            <item.icon className={classes.btnIcon} />
            <span>{item.label}</span>
          </a>
        </Link>
      ))}
      <Text
        size={Typography.t4}
        weight={FontWeights.Bold}
        className={classes.label}
        elementType={TextElementTypes.H3}
      >
        {t('editor.tools')}
      </Text>

      <ul className={classes.container}>
        {MENU_CATEGORIES.map((item) => {
          const { type, text, icon } = item;
          const selected = type === selectedMenuCategoryType;
          const isExpanded = expandedMenuCategoryType === type;

          return (
            <li key={`${text}${type}`}>
              <div
                onClick={() => {
                  toggleMenuItem(type);
                }}
                className={cls(classes.textContainer, selected && classes.textContainerSelected)}
              >
                <SingleToolAppIcon
                  isRound
                  size="xsmall"
                  icon={{
                    ...CATEGORY_ICON_PROPS,
                    src: icon,
                  }}
                />
                <Text
                  size={Typography.t4}
                  className={classes.categoryText}
                  weight={FontWeights.SemiBold}
                >
                  {text}
                </Text>
                <IconChevronDownSmall
                  className={cls(classes.smallIcon, isExpanded && classes.smallIconInverse)}
                />
              </div>

              <Subcategories
                isExpanded={expandedMenuCategoryType === type}
                items={item.subcategories}
                selectedMenuCategoryType={selectedMenuCategoryType}
                selectedMenuSubcategory={selectedMenuSubcategory}
                setMenuSelectedItem={setMenuSelectedItem}
                ownCategoryType={type}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
export default Menu;
